export default function getCompanyId(state: any) {
  return state.page?.data?.zone?.companyId ?? '';
}
